import React, { useState } from 'react';
import ListingCard from '../components/ListingCard';
import ListingDetail from '../components/ListingDetail';
import { useListings } from '../hooks/useFirestore';

const WA_LINK = 'https://wa.me/971585338786';

export default function BrandPage({ brand, title, description, seoTitle, seoDescription }) {
  const { listings, loading } = useListings({ status: 'Listed' });
  const [selected, setSelected] = useState(null);

  const filtered = listings.filter(l => l.brand === brand);
  const waLink = `${WA_LINK}?text=Hi%20I%20am%20interested%20in%20${encodeURIComponent(brand)}%20bikes`;

  // Update page title for SEO
  React.useEffect(() => {
    document.title = seoTitle || `${title} | eBike Dubai`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && seoDescription) metaDesc.setAttribute('content', seoDescription);
  }, [seoTitle, seoDescription, title]);

  return (
    <div className="fade-in" style={{ maxWidth: 1200, margin: '0 auto', padding: '32px 20px' }}>
      <div style={{ textAlign: 'center', padding: '40px 0' }}>
        <h1 style={{ fontSize: 36, marginBottom: 12 }}>{title}</h1>
        <p style={{ color: 'var(--text-2)', fontSize: 16, maxWidth: 600, margin: '0 auto 24px' }}>{description}</p>
        <a href={waLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
          <button className="btn-wa">💬 Ask about {brand}</button>
        </a>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-2)' }}>Loading...</div>
      ) : filtered.length > 0 ? (
        <div className="grid-3">
          {filtered.map(l => <ListingCard key={l.id} listing={l} onClick={setSelected} />)}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: 60, color: 'var(--text-2)' }}>
          <p style={{ marginBottom: 16 }}>No {brand} bikes currently listed.</p>
          <a href={waLink} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <button className="btn-wa">💬 Get notified when available</button>
          </a>
        </div>
      )}

      {selected && <ListingDetail listing={selected} onClose={() => setSelected(null)} />}
    </div>
  );
}
